export const LEGAL_UPDATED = "17 September 2026";
